// redux
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../../store';
import { actualizarEjercicioUsuario } from '../../../../store/slices/ejercicio';
import FormularioAntiderivada from './FormularioAntiderivada';
import FormularioEcuacion from './FormularioEcuacion';
import FormularioFormula from './FormularioFormula';
import FormularioIntervalo from './FormularioIntervalo';

import FormularioNumero from './FormularioNumero';
import FormularioPunto from './FormularioPunto';
import FormularioSM from './FormularioSM';
import FormularioVector from './FormularioVector';

type Props = {
    eid: string
    tipo: string
    respuesta: string
    alternativas: Array<Alternativa>
}

type Alternativa = {
    letra: string
    alternativa: string
    estado: boolean
}

const Formulario = ({ eid, tipo, respuesta, alternativas }: Props) => {

    const dispatch = useDispatch<AppDispatch>();

    const handleRespuestaUsuario = (estado: any) => {
        dispatch(actualizarEjercicioUsuario(eid, estado.ok))
    }

    if (tipo === 'numerico') {
        return (
            <FormularioNumero
                handleRespuestaUsuario={handleRespuestaUsuario}
                respuesta={respuesta}
            />
        )
    }

    if (tipo === 'intervalo') {
        return (
            <FormularioIntervalo
                handleRespuestaUsuario={handleRespuestaUsuario}
                respuesta={respuesta}
            />
        )
    }

    if (tipo === 'formula') {
        return (
            <FormularioFormula
                handleRespuestaUsuario={handleRespuestaUsuario}
                respuesta={respuesta}
            />
        )
    }

    if (tipo === 'ecuacionXY') {
        return (
            <FormularioEcuacion
                handleRespuestaUsuario={handleRespuestaUsuario}
                respuesta={respuesta}
            />
        )
    }

    if (tipo === 'punto') {
        return (
            <FormularioPunto
                handleRespuestaUsuario={handleRespuestaUsuario}
                respuesta={respuesta}
            />
        )
    }

    if (tipo === 'vector') {
        return (
            <FormularioVector
                handleRespuestaUsuario={handleRespuestaUsuario}
                respuesta={respuesta}
            />
        )
    }

    if (tipo === 'antiderivada') {
        return (
            <FormularioAntiderivada
                handleRespuestaUsuario={handleRespuestaUsuario}
                respuesta={respuesta}
            />
        )
    }

    if (tipo === 'seleccion-multiple') {
        return (
            <FormularioSM
                eid={eid}
                handleRespuestaUsuario={handleRespuestaUsuario}
                alternativas={alternativas}
            />
        )
    }

    return (
        <div>PENDIENTE</div>
    )
}

export default Formulario;